<template>
    <!--Start Page Banner-->
    <div class="page-banner-area bg-1">
            <div class="container">
                <div class="page-banner-content">
                    <h1>WDC</h1>
                    <ul>
                        <li><a href="/">Home</a></li>
                        <li>Student Corner</li>
                        <li>Cells</li>
                        <li>WDC</li>
                    </ul>
                </div>
            </div>
        </div>
        <!--End Page Banner-->

        <!--Start WDC Area-->
        <div class="privacy-policy-area pt-100 pb-70">
            <div class="container">
                <div class="row">
                    <div class="col-lg-8">
                        <div class="privacy-content pr-20">
                            <h2>Women Development Cell</h2>
                            <p>Please read this Women Development Cell details carefully </p>

                            <p>Women Development Cell provides a respectful and conducive working environment for women employees and students of the college.</p>

                            <p>There is a committee formed to do this. Through this, the aim is to stop discrimination against women on the basis of gender related issues and to provide a respectable place to women.</p>

                            <p>In the college, work is done to make the girl students aware of their rights through various activities like lectures, plays, poems, posters, workshops etc. So that women's rights can be protected and they can understand themselves at the level of men's society.</p>

                        </div>
                    </div>

                    <div class="col-lg-4">
                        <div class="privacy-left-content pl-20">
                            <div class="team-img-box"> <img width="460" height="500"
                                    src="/vf/images/cells/C1_inner.png"
                                    class="attachment-post-thumbnail size-post-thumbnail wp-post-image" alt=""
                                    decoding="async" fetchpriority="high"></div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <!--End WDC Area-->


        <!-- Start Bottom Connect Area -->
        <div class="alumni-interview-area pb-100">
            <div class="container">
                <div class="interview-content ptb-100">
                    <div class="interview">
                        <a href="https://rdc.eshala.co.in/events" class="default-btn btn">Events<i
                                class="flaticon-next"></i></a>
                        <a href="https://rdc.eshala.co.in/page/enquiry" class="default-btn btn">Apply Now<i
                                class="flaticon-next"></i></a>
                    </div>
                </div>
            </div>
        </div>
        <!--End Bottom Connect Area -->
</template>

<script>
export default {
    name : "WDCView"
};
</script>
